import { pageSelectorGenerator } from '@test/pageSelectors';

export const RegistryItemNotFoundSelectors = pageSelectorGenerator('RegistryItemNotFound', ['ContainerElement', 'CloseButton']);
